import { h, clear } from '../utils/dom.js';
import { READING_PLANS, buildPlanChapterList, getDayReading, currentDayNumber } from '../reading-plans.js';

function renderPlanPicker(container, state, actions) {
	container.appendChild(h('p', { class: 'blb-search-hint' }, 'Pick a reading plan to start tracking your progress.'));

	READING_PLANS.forEach((plan) => {
		container.appendChild(
			h('div', { class: 'blb-plan-card' }, [
				h('div', { class: 'blb-plan-card-name' }, plan.name),
				h('div', { class: 'blb-plan-card-desc' }, plan.description),
				h('div', { class: 'blb-plan-card-desc' }, `${plan.days} days`),
				h(
					'button',
					{ class: 'blb-toolbar-btn blb-active', onClick: () => actions.startPlan(plan.id) },
					'Start Plan'
				),
			])
		);
	});
}

function renderActivePlan(container, state, actions) {
	const { plan } = state;
	const def = READING_PLANS.find((p) => p.id === plan.planId);
	if (!def) {
		container.appendChild(h('p', { class: 'blb-search-hint' }, 'This plan is no longer available.'));
		container.appendChild(
			h('button', { class: 'blb-toolbar-btn', onClick: () => actions.stopPlan() }, 'Choose a different plan')
		);
		return;
	}

	const chapterLists = buildPlanChapterList(state.index, def);
	const day = currentDayNumber(plan.startedAt, plan.totalDays);
	const todayReading = getDayReading(chapterLists, plan.totalDays, day);
	const isDayDone = plan.completedDays.includes(day);
	const pct = Math.round((plan.completedDays.length / plan.totalDays) * 100);

	container.appendChild(h('div', { class: 'blb-plan-card-name' }, def.name));

	container.appendChild(
		h('div', { class: 'blb-plan-progress-track' }, [h('div', { class: 'blb-plan-progress-fill', style: `width:${pct}%;` })])
	);
	container.appendChild(
		h('p', { class: 'blb-search-hint' }, `Day ${day} of ${plan.totalDays} · ${plan.completedDays.length} days completed (${pct}%)`)
	);

	container.appendChild(h('div', { class: 'blb-section-heading' }, `Today's Reading`));

	todayReading.forEach((entry) => {
		container.appendChild(
			h(
				'button',
				{
					class: 'blb-search-result',
					onClick: () => actions.goToReference({ book: entry.book, chapter: entry.chapter }),
				},
				h('div', { class: 'blb-search-result-ref' }, `${entry.bookName} ${entry.chapter}`)
			)
		);
	});

	container.appendChild(
		h(
			'button',
			{
				class: 'blb-toolbar-btn' + (isDayDone ? ' blb-active' : ''),
				onClick: () => actions.toggleDayComplete(day),
				style: 'margin-top:10px;',
			},
			isDayDone ? '✓ Day complete' : 'Mark today complete'
		)
	);

	container.appendChild(
		h(
			'button',
			{ class: 'blb-toolbar-btn', onClick: () => actions.stopPlan(), style: 'margin-top:6px;' },
			'Switch / stop plan'
		)
	);
}

export function renderPlanPanel(container, state, actions) {
	clear(container);

	if (!state.index) {
		container.appendChild(h('p', { class: 'blb-search-hint' }, state.i18n.loading));
		return;
	}

	if (state.plan) {
		renderActivePlan(container, state, actions);
	} else {
		renderPlanPicker(container, state, actions);
	}
}
